import {
  collection,
  getDocs,
  doc,
  getDoc,
  query,
  where,
} from "firebase/firestore";
import { db } from "../../firebase";

const GetSingleDeal = async (DealId) => {
  /**
   * input: DealId
   * output: deal document
   * description: get single deal data
   */

  try {
    const dealDocument = doc(db, "deals", DealId);
    const dealSnapshot = await getDoc(
      dealDocument,
      where("is_deleted", "==", false)
    );
    let dealData = {
      id: dealSnapshot.id,
      ...dealSnapshot.data(),
      transactions: [],
      visits: [],
    };
    /** Get all transactions of this deal */
    let transactionsSnapshot = await getDocs(
      collection(dealDocument, "transactions")
    );
    transactionsSnapshot.docs.forEach((DOC) => {
      const id = DOC.id;
      const d = { ...DOC.data() };
      delete d.modifiedAt;
      delete d.modifiedBy;
      dealData.transactions.push({ ...d, id });
    });
    /** Get all visits of this deal */
    let visitsSnapshot = await getDocs(
      query(collection(db, "visits"), where("dealId", "==", DealId))
    );
    visitsSnapshot.docs.forEach((DOC) => {
      const id = DOC.id;
      const d = { ...DOC.data() };
      delete d.modifiedAt;
      delete d.modifiedBy;
      dealData.visits.push({ ...d, id });
    });
    return dealData;
  } catch (error) {
    console.log(error);
  }
};

export default GetSingleDeal;
